var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-password"},[_c('Content',[_c('h1',{staticClass:"h4 text-center mb-6"},[_vm._v("Create your password")]),_c('CreatePassword',{on:{"submit":_vm.changePassword}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }